// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"_404-module--NotFound--1p22g"};